var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(!_vm.raw_messages)?_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"table"}}):_c('DataTableVT',{attrs:{"headers":_vm.page_content.messages_table,"sort_by":"TimestampISO","items_list":_vm.raw_messages,"no_search":_vm.no_search,"isTransitionOn":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }